module.exports = __webpack_public_path__ + "static/media/phoenix.6a1da94c.png";